export const panelRoute = [
  {
    path: "/panelapproval",
    name: "PanelApproval",
    component: () => import("@/views/Panel/PanelistApproval.vue"),
  },
  {
    path: "/instructorapproval",
    name: "InstructorApproval",
    component: () => import("@/views/Instructor/InstructorApproval.vue"),
  },
  {
    path: "/instructorpage",
    name: "InstructorPage",
    component: () => import("@/views/Instructor/InstructorPage.vue"),
  },
  {
    path: "/panelpage",
    name: "PanelPage",
    component: () => import("@/views/Panel/PanelistPage.vue"),
  },
  {
    path: "/paneldetails",
    name: "PanelDetails",
    component: () => import("@/views/Panel/PanelDetails.vue"),
  },
  {
    path: "/panelfeedback",
    name: "PanelFeedback",
    component: () => import("@/views/Panel/PanelFeedback.vue"),
  },
  {
    path: "/ticketsystem",
    name: "TicketSystem",
    component: () => import("@/views/TicketSystem/TicketSystem.vue"),
  },
  {
    path: "/viewticket",
    name: "ViewTicket",
    component: () => import("@/views/TicketSystem/ViewTicket.vue"),
  },
  {
    path: "/RestrictedAccess",
    name: "RestrictedAccess",
    component: () => import("@/views/Panel/RestrictedAccess.vue"),
  },
  {
    path: "/jobs",
    name: "Jobs",
    component: () => import("@/views/Jobs/Jobs.vue"),
  },
  {
    path: "/instructor",
    name: "Instructor",
    component: () => import("@/views/Instructor/Instructor.vue"),
    meta: {
      title: "Instructor",
    },
  },
];
